
import { User } from '@supabase/supabase-js';
import { AuthUser } from '@/types/auth';

/**
 * Converts a Supabase User object to our custom AuthUser type
 */
export const convertUserToAuthUser = (supabaseUser: User): AuthUser => {
  return {
    id: supabaseUser.id,
    email: supabaseUser.email,
    // Don't include role here as it will be set when fetching the profile
    user_metadata: supabaseUser.user_metadata,
    app_metadata: supabaseUser.app_metadata
  };
};
